import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NotFoundPage } from 'pages';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import CommonRoutes from './CommonRoutes';

const routeList = PrivateRoutes.concat(PublicRoutes, CommonRoutes);

const routes = (
  <Switch>
    {routeList.map(({ path, component, exact }) => (
      <Route
        key={`Route-${path}`}
        path={path}
        component={component}
        exact={exact}
      />
    ))}
    <Route component={NotFoundPage} />
  </Switch>
);

export default routes;
